module.exports = __webpack_public_path__ + "static/media/flat-tire.072c2078.svg";